import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface BaseApiEndpoint {
  instance: AxiosInstance;
}

export class BaseApi implements BaseApiEndpoint {
  instance: AxiosInstance;
  constructor(config: AxiosRequestConfig) {
    this.instance = axios.create({
      ...config,
      // we are using a custom serializer because axios is encoding things their own special way
      // for our use case we need to encode a different way
      paramsSerializer: (params: any) => {
        // we do not want to pass undefined fields to backend so we delete them off
        Object.keys(params).forEach((key) => {
          if (params[key] === undefined) {
            delete params[key];
          }
        });

        // URLSearchParams encodes all special characters however we need to replace all + with %20
        // so we do not make a bunch of breaking changes to our backend
        return new URLSearchParams(params).toString().replace(/\+/g, '%20');
      },
    });
  }
}
